import React from "react";
import { withTranslation } from "react-i18next";
import defaultImage from "assets/images/Christmas/Card Red.jpg";
import EnhancedImage from "components/EnhancedImage";

const SPLITTER = " - ";
const NO_DATA = "-";

const VoucherBox = ({ t, imageRootUrl, imagePath, giftcardName }) => {
  const getTerm = () => {
    return `${giftcardName && (giftcardName.split(SPLITTER)[1] || NO_DATA)}`;
  };

  const getUniverse = () => {
    return ` ${giftcardName && (giftcardName.split(SPLITTER)[0] || NO_DATA)}`;
  };

  const isTextDark = () => {
    if ((getUniverse().toLowerCase().trim() === "classical & jazz" || getUniverse().toLowerCase().trim() === "classique & jazz") && getTerm() !== NO_DATA) {
      return true;
    }
    return false;
  };

  return (
    <div className="voucher-box">
      <div className="voucher-box__image-container">
        <div className={`voucher-box__image-container__text1${isTextDark() ? " dark-text" : ""}`}>{t("GIFTCARD_IMAGE_BOX_TEXT1")}</div>
        <div className={`voucher-box__image-container__text2${isTextDark() ? " dark-text" : ""}`}>{t("GIFTCARD_IMAGE_BOX_TEXT2", { term: getTerm(), universe: getUniverse() })}</div>
        <EnhancedImage size="large" imageRootUrl={imageRootUrl} imagePath={imagePath} fallbackImage={defaultImage} />
      </div>
      <div className="voucher-box__text-container">
        <div className="voucher-box__text-container__title">{t("VOUCHER_GIFTBOX_TITLE")}</div>
        <p className="voucher-box__text-container__description">{t("VOUCHER_GIFTBOX_DESCRIPTION")}</p>
      </div>
    </div>
  );
};

export default withTranslation()(VoucherBox);
